import { useEffect, useState } from "react";

export const Alerta = ({ history, mensaje = "", tipo, show, setShow, setShowModalRedemption = () => { } }) => {

    const [counter, setCounter] = useState(show ? 1 : 0);

    let url = "#";
    let mensajeA = "";
    let mensajeB = "";

    if (0 == tipo) {
        const first = mensaje.split("-")
        const aux = first[0].split(",");
        mensajeA = aux[0];
        mensajeB = aux[1];
        url = `#`;
    } else if (1 == tipo) {
        const aux = mensaje.split(",");
        mensajeA = aux[0];
        mensajeB = aux[1];
        url = `./MiPerfil/MisPedidos`;
    }
    else {
        mensajeA = mensaje;
    }

    let timer = setTimeout(0);

    // if (setShow) {
    //     timeOut = setTimeout(() => setShow(false), 8000);
    // }


    const handleCancelClick = () => {
        // clearTimeout(timeOut);
    }
    //Ejemplo de timeOut -> https://erikmartinjordan.com/clear-timeout-react-hooks
    /** 
    */

    useEffect(() => {
        if (counter && counter <= 2){
            timer = setTimeout(() => setCounter(counter + 1), 15 * 1000); // 15 SEG
        }
        else if (setShow)
            setShow(false);
        return () => clearTimeout(timer);
    }, [counter]);

    const startCounter = () => setCounter(counter + 1);
    const stopCounter = () => {
        setCounter(0);
        setShow(false);
    };

    return (
        <>
            <div
                className={"alerta " + (show ? "" : "hide")}
            >
                <div
                    className="alerta-mensaje"
                >
                    <p>
                        {mensajeA}
                        <a
                            onClick={
                                () => {
                                    if (tipo == 0) {
                                        setShowModalRedemption(true);
                                    } else {
                                        history.push(
                                            {
                                                pathname: url,
                                            }
                                        )
                                    }
                                }
                            }
                        >
                            {mensajeB}
                        </a>
                    </p>
                </div>
                <div className="alerta-icono">
                    <svg
                        width="33" height="33"
                        viewBox="0 0 33 33" fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={stopCounter}
                    >
                        <circle cx="16.2637" cy="16.2635" r="11" transform="rotate(45 16.2637 16.2635)" fill="white" stroke="#7FB9DD" />
                        <path d="M19.5722 20.986L11.6007 13.0145C11.2448 12.6586 11.243 12.0911 11.5965 11.7376L11.738 11.5961C12.0915 11.2426 12.6591 11.2444 13.0149 11.6003L20.9152 19.5006C21.2711 19.8565 21.2729 20.424 20.9194 20.7775L20.8487 20.8483C20.4956 21.3437 19.928 21.3418 19.5722 20.986Z" fill="#7FB9DD" />
                        <path d="M11.5405 19.5716L19.512 11.6002C19.8678 11.2443 20.4354 11.2424 20.7889 11.596L20.9303 11.7374C21.2839 12.091 21.282 12.6585 20.9262 13.0144L13.0259 20.9146C12.67 21.2705 12.1025 21.2724 11.7489 20.9188L11.6782 20.8481C11.1828 20.495 11.1846 19.9275 11.5405 19.5716Z" fill="#7FB9DD" />
                    </svg>
                </div>
            </div>
        </>
    )
}
